import $ from 'jquery';
import {gsap} from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import CustomAnimation from "src/scripts/animation/customAnimation";

const customAnmation = new CustomAnimation();

class Zunaechst {
  init() {
    this.initPage();
    this.initParallax();
    this.onScroll();
  }

  initPage = () => {
    $('.zunaechst_header').addClass('show');
    //$('.content_image_arrow img').css('top', $('.content_image').height()/2 + 'px');
  }

  initParallax = () =>  {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header_background');
    customAnmation.scaleBgImage('.zunaechst_background', '.zunaechst_intro');
    customAnmation.scaleBgImage('.zustaendig_background', '.zustaendig');
    customAnmation.scaleBgImage('.zugehoerig_background', '.zugehoerig');
    customAnmation.scaleBgImage('.zuordnung_background', '.zuordnung');
    customAnmation.scaleBgImage('.zustark_background', '.zustark');
    customAnmation.scaleBgImage('.zusammen_background', '.zusammen');
    customAnmation.scaleBgImage('.zugewinn_background', '.zugewinn');
    customAnmation.scaleBgImage('.zukuenftig_background', '.zukuenftig');
    customAnmation.scaleBgImage('.zugestaendnisse_background', '.zugestaendnisse');



    customAnmation.animateHeadlineGroup('.headline_text');
    customAnmation.animateTextGroup('.content_text');
    customAnmation.animateImageGroup('.content_image');
  }

  onScroll = () => {
    jQuery(window)
      .scroll(function () {
        //$('.content_image_arrow img').css('top', $('.content_image').height()/2 + 'px');
      }).scroll();
  };
}

export default Zunaechst;
